"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_polyglot_1 = require("react-polyglot");
const Html_1 = __importDefault(require("components/Html"));
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const translation_1 = require("modules/translation");
const LabelUtils_1 = __importDefault(require("./LabelUtils"));
class I18n extends react_1.Component {
    isUntranslated(label, translated) {
        return !translated || label === translated;
    }
    getFallbackLabel(label, data, locale) {
        const { enPolyglot, ptPolyglot, html, className } = this.props;
        let fallbackLabel = label;
        if (locale.toLowerCase() !== translation_1.LOCALES.EN) {
            fallbackLabel = enPolyglot === null || enPolyglot === void 0 ? void 0 : enPolyglot.t(label, data);
        }
        if (this.isUntranslated(label, fallbackLabel)) {
            fallbackLabel = ptPolyglot === null || ptPolyglot === void 0 ? void 0 : ptPolyglot.t(label, data);
        }
        if (this.isUntranslated(label, fallbackLabel)) {
            return `$i18n.${label}`;
        }
        if (html) {
            return (0, jsx_runtime_1.jsx)(Html_1.default, { className: className, children: fallbackLabel });
        }
        return fallbackLabel;
    }
    render() {
        const { label, className, html, locale, t, checkOnlineEvent } = this.props;
        const data = { ...this.props.data, locale };
        if (typeof label === 'string' && label !== '') {
            const customLabel = LabelUtils_1.default.customize(label, {
                amountToPluralize: data === null || data === void 0 ? void 0 : data.count,
                checkOnlineEvent,
                data
            });
            const translated = t(customLabel, data);
            if (this.isUntranslated(customLabel, translated)) {
                return this.getFallbackLabel(customLabel, data, locale);
            }
            if (html) {
                return (0, jsx_runtime_1.jsx)(Html_1.default, { className: className, children: translated });
            }
            return translated;
        }
        return label;
    }
}
I18n.defaultProps = {
    checkOnlineEvent: false
};
exports.default = (0, flowRight_1.default)((0, mobx_react_1.inject)((stores) => ({
    locale: stores.UserStore.locale,
    enPolyglot: stores.UserStore.enPolyglot,
    ptPolyglot: stores.UserStore.ptPolyglot
})), (0, react_polyglot_1.translate)())(I18n);
